<template>
    <div
        :class="[$style['mds-loader'], classObject, sizeClass]"
        role="progressbar"
        :aria-valuetext="ariaValuetext"
        :data-mds-version="version"
    >
        <div v-for="n in 8" :key="n" :class="[$style['mds-loader__item'], $style[`mds-loader__item--${n}`]]"></div>
    </div>
</template>

<script>
    import MdsLoaderProps from './loader_props.js';

    export default {
        name: 'MdsLoader',
        props: MdsLoaderProps,
        computed: {
            sizeClass() {
                return this.$style[`mds-loader--${this.size}`];
            },
            classObject() {
                const obj = {};
                obj[this.$style['mds-component--on-dark']] = this.onDark;

                return obj;
            },
        },
    };
</script>

<style lang="scss" module>
    @import './loader.scss';
</style>
